/**
 * @generated SignedSource<<6701cee7af0f3076e3fa9b93c792bd0b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RemoveStudyPanelRecruitsInput = {
  clientMutationId?: string | null;
  panelistIds: ReadonlyArray<string>;
  recruitId: string;
};
export type RecruitMatch_removeStudyPanelRecruits_Mutation$variables = {
  input: RemoveStudyPanelRecruitsInput;
};
export type RecruitMatch_removeStudyPanelRecruits_Mutation$data = {
  readonly removeStudyPanelRecruits: {
    readonly errors: ReadonlyArray<{
      readonly data: any | null;
      readonly message: string | null;
    } | null> | null;
    readonly study: {
      readonly id: string;
    } | null;
  } | null;
};
export type RecruitMatch_removeStudyPanelRecruits_Mutation = {
  response: RecruitMatch_removeStudyPanelRecruits_Mutation$data;
  variables: RecruitMatch_removeStudyPanelRecruits_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RemoveStudyPanelRecruitsPayload",
    "kind": "LinkedField",
    "name": "removeStudyPanelRecruits",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "StudyNode",
        "kind": "LinkedField",
        "name": "study",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Errors",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "data",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RecruitMatch_removeStudyPanelRecruits_Mutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RecruitMatch_removeStudyPanelRecruits_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "fbeb6cbd27d4945e3884fc0c937d6a29",
    "id": null,
    "metadata": {},
    "name": "RecruitMatch_removeStudyPanelRecruits_Mutation",
    "operationKind": "mutation",
    "text": "mutation RecruitMatch_removeStudyPanelRecruits_Mutation(\n  $input: RemoveStudyPanelRecruitsInput!\n) {\n  removeStudyPanelRecruits(input: $input) {\n    study {\n      id\n    }\n    errors {\n      message\n      data\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9fe1b973cc03f8559f74c4707e293291";

export default node;
